import { render } from "./DeviceCheck.vue?vue&type=template&id=f2c44b60"
import script from "./DeviceCheck.vue?vue&type=script&lang=js"
export * from "./DeviceCheck.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.3.0_webpack@5.92.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__